import React from 'react';

export default ({imageUrl, title, ...props}) => (
    <div className="trit-qrcode" {...props}>
        <img src={imageUrl} alt="" />
        {title
            ?<div className="title">{title}</div>                                    
            :null
        }
    </div>
);
